<template>
  <standard-layout header="Neue Bestellung mit nicht existentem Produkt">
    <template v-slot:main>
      <div class="row h5">
        <div class="col-12"
             v-if="order.number">
          Bestellung {{ order.number }}
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <div>Kunde</div>
          <div>
            <Search @select="entrySelected($event)" type="customer"/>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-12">
              <label for="customerEmail">Email</label>
              <input id="customerEmail"
                     type="email"
                     class="form-control"
                     v-model="order.customer.email"/>
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="customerFirstName">Vorname</label>
              <input id="customerFirstName"
                     type="text"
                     class="form-control"
                     v-model="order.customer.firstName"/>
            </div>
            <div class="col-12 col-md-6 form-group">
              <label for="customerLastName">Nachname</label>
              <input id="customerLastName"
                     type="text"
                     class="form-control"
                     v-model="order.customer.lastName"/>
            </div>
            <div class="col-12 col-md-12">
              <label for="customerCompany">Firma</label>
              <input id="customerCompany"
                     type="text"
                     class="form-control"
                     v-model="order.customer.company"/>
            </div>
            <div class="col-12 col-md-12 form-group">
              <label for="customerStreetAndNumberInput">Straße und Nummer</label>
              <input id="customerStreetAndNumberInput"
                     type="text"
                     class="form-control"
                     v-model="order.customer.streetAndNumber"/>
            </div>
            <div class="col-4 col-md-3 form-group">
              <label for="customerZipInput">PLZ</label>
              <input id="customerZipInput"
                     type="text"
                     class="form-control"
                     v-model="order.customer.zip"/>
            </div>
            <div class="col-8 col-md-9 form-group">
              <label for="customerCityInput">Stadt</label>
              <input id="customerCityInput"
                     type="text"
                     class="form-control"
                     v-model="order.customer.city"/>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3">
        <div class="card-header">Bestellung</div>
        <div class="card-body">
          <div class="form-group">
            <label for="relatedToOrderIdSearch">gehört zu Bestellung</label>
            <search type="order" id="relatedToOrderIdSearch" @select="order.relatedToOrderId = $event ? $event.id : null"/>
          </div>
          <div class="form-group">
            <label for="productNameInput">Name des Produktes</label>
            <input class="form-control" id="productNameInput" v-model="order.positions[0].article.product.name" type="text">
          </div>
          <div class="form-group">
            <label for="productDescriptionInput">Beschreibung des Produktes</label>
            <input class="form-control" id="productDescriptionInput" v-model="order.positions[0].article.product.description" type="text">
          </div>
          <div class="form-group">
            <label for="priceInput">Preis</label>
            <input class="form-control" id="priceInput" v-model.number="order.totalGrossPrice" type="number">
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12 text-right">
          <div class="btn btn-primary"
               @click="submit">
            Bestellung speichern
          </div>
        </div>
      </div>
    </template>
  </standard-layout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout";
import Search from "@/components/search/Search";

export default {
  data() {
    return {
      order: {
        number: undefined,
        customer: {
          id: undefined,
          email: undefined,
          firstName: undefined,
          lastName: undefined,
          streetAndNumber: undefined,
          zip: undefined,
          city: undefined,
          countryCode: 'de',
          phone: undefined
        },
        positions: [{
          article: {
            product: {
              name: '',
              description: '',
              category: 'XTR',
              pricingType: 'byPiece'
            }
          },
          grossPrice: 0,
          vatRate: 0.19,
          quantity: 1
        }],
        state: undefined,
        totalGrossPrice: 0,
        relatedToOrderId: null
      },
    }
  },
  computed: {
    customerName() {
      if (this.customer.firstName || this.customer.lastName)
        return this.customer.firstName + ' ' + this.customer.lastName
      return undefined
    }
  },
  methods: {
    async entrySelected(searchEntry) {
      if (searchEntry.type !== 'customer')
        this.showError('Bitte wähle einen Kunden')
      else {
        this.order.customer = await this.$api.get(`/customers/${searchEntry.id}`)
            .then(res => this.order.customer = res.data)
            .catch(err => this.handleError(err))
      }
    },
    submit() {
      const payload = {
        ...this.order,
        totalVat: this.order.totalGrossPrice / 1.19 * 0.19
      }
      const pos = this.order.positions[0]
      pos.totalGrossPrice = this.order.totalGrossPrice
      pos.vatRate = 0.19
      pos.totalVat = this.order.totalGrossPrice / (1 + pos.vatRate) * pos.vatRate
      pos.article.grossPrice = pos.totalGrossPrice
      pos.article.vatRate = pos.vatRate
      this.$api.post('/orders', payload)
          .then(response => this.$router.push({name: 'orderDetail', params: {id: response.data.id}}))
          .catch(error => this.handleError(error))
    }
  },
  mounted() {
    if (this.$route.query.order) {
      this.$api.get(`/orders/${this.$route.query.order}`)
          .then(response => this.order = response.data)
          .catch(error => this.handleError(error))
    }
  },
  components: {
    StandardLayout,
    Search
  }
}

</script>

<style type="scss">
</style>


